// Single source of truth for Workforce Intelligence skill areas.
// MUST mirror the backend WieSkillMappingService.AllSkills (order) and SkillLabel() (labels).
// Used by the Team Setup and Scenario modals so the list can't drift / drop a skill.
export const WIE_SKILLS = [
  { key: "SecOps",            label: "Security Operations" },
  { key: "IAM",               label: "Identity & Access Mgmt" },
  { key: "GRC",               label: "Governance, Risk & Compliance" },
  { key: "IR",                label: "Incident Response" },
  { key: "CloudSecurity",     label: "Cloud Security" },
  { key: "AppSec",            label: "Application Security" },
  { key: "DataSecurity",      label: "Data Security" },
  { key: "TPRM",              label: "Third-Party Risk" },
  { key: "EndpointSecurity",  label: "Endpoint Security" },
  { key: "ProjectManagement", label: "Security Program Management" },
];

export const WIE_SKILL_KEYS   = WIE_SKILLS.map(s => s.key);
export const WIE_SKILL_LABELS = Object.fromEntries(WIE_SKILLS.map(s => [s.key, s.label]));
